import Documentations from "./components/Documentations";

const DocumentationPage = () => {
  return (
    <div className="min-h-screen font-proximaNova">
      <div className="flex justify-center my-12" id="documentations">
        <Documentations />
      </div>
    </div>
  );
};

export default DocumentationPage;
